import api from "../../system/api";

/**
 * Uploads an image or video to the public help media storage (upload.zofino.ir in production) through the
 * admin-only endpoint of Strapi and resolves {url, name, kind}. `onProgress` receives 0..100.
 * Same signature as the editor's `uploader`: uploader(file | blob, {fileName, signal, onProgress}).
 */
export async function uploadHelpMedia(file, {fileName, signal, onProgress} = {}) {
    const baseURL = api.defaults.baseURL || window.location.origin;
    const url = new URL("../admin/help-media/upload", baseURL).toString();
    const form = new FormData();
    form.append("file", file, fileName || file.name || "file");
    const {data} = await api.post(url, form, {
        signal,
        timeout: 0,
        onUploadProgress: (event) => {
            if (event.total) onProgress?.(Math.round((event.loaded / event.total) * 100));
        },
    });
    const result = data?.data || data || {};
    return {url: result.url, name: fileName || file.name, kind: result.kind};
}
